
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const teamMembers = [
    {
      name: '张明',
      position: '创始人 & CEO',
      description: '前央视体育频道资深制作人，15年体育媒体经验',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20business%20executive%20portrait%2C%20confident%20male%20CEO%20in%20business%20suit%2C%20modern%20corporate%20headshot%20with%20clean%20background%2C%20professional%20lighting%20and%20composition&width=300&height=300&seq=ceo-zhang&orientation=squarish'
    },
    {
      name: '李雪',
      position: '技术总监',
      description: '前阿里巴巴高级工程师，专注视频流媒体技术',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20technology%20director%20portrait%2C%20confident%20woman%20in%20business%20attire%2C%20modern%20tech%20executive%20headshot%20with%20clean%20background%2C%20professional%20corporate%20photography&width=300&height=300&seq=cto-li&orientation=squarish'
    },
    {
      name: '王强',
      position: '产品总监',
      description: '前腾讯产品经理，擅长用户体验设计',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20product%20director%20portrait%2C%20friendly%20business%20executive%20in%20modern%20office%20setting%2C%20clean%20corporate%20headshot%20with%20natural%20lighting&width=300&height=300&seq=cpo-wang&orientation=squarish'
    },
    {
      name: '陈晨',
      position: '运营总监',
      description: '体育营销专家，曾服务多家知名体育品牌',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20marketing%20director%20portrait%2C%20confident%20woman%20executive%20in%20business%20environment%2C%20modern%20corporate%20headshot%20with%20professional%20lighting&width=300&height=300&seq=cmo-chen&orientation=squarish'
    }
  ];

  const milestones = [
    {
      year: '2020',
      title: '公司成立',
      description: '贝斯特体育在北京正式成立，致力于打造专业体育直播平台'
    },
    {
      year: '2021',
      title: '产品上线',
      description: '首个版本正式发布，支持足球、篮球等主流体育项目直播'
    },
    {
      year: '2022',
      title: '用户突破',
      description: '注册用户突破10万，日活跃用户达到5万'
    },
    {
      year: '2023',
      title: '技术升级',
      description: '引入4K高清直播技术，用户体验大幅提升'
    },
    {
      year: '2024',
      title: '全面发展',
      description: '用户超50万，成为国内领先的体育直播平台'
    }
  ];

  const values = [
    {
      icon: 'ri-eye-line',
      title: '专业',
      description: '专业的体育内容制作团队，为用户提供高质量的体育直播和资讯'
    },
    {
      icon: 'ri-heart-line',
      title: '热情',
      description: '对体育运动的无限热爱，用心服务每一位体育爱好者'
    },
    {
      icon: 'ri-rocket-line',
      title: '创新',
      description: '不断探索新技术，为用户带来更好的观赛体验'
    },
    {
      icon: 'ri-team-line',
      title: '共享',
      description: '打造开放的体育社区，让每个人都能分享体育的快乐'
    }
  ];

  const stats = [
    { number: '50万+', label: '注册用户', icon: 'ri-user-line' },
    { number: '1000+', label: '每日直播', icon: 'ri-live-line' },
    { number: '100+', label: '合作赛事', icon: 'ri-trophy-line' },
    { number: '24/7', label: '在线服务', icon: 'ri-customer-service-line' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section 
          className="relative h-[50vh] md:h-[60vh] flex items-center justify-center text-white overflow-hidden"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20with%20glass%20facade%20and%20professional%20architecture%2C%20business%20headquarters%20with%20green%20landscaping%2C%20clean%20corporate%20environment%20with%20natural%20lighting%20and%20contemporary%20design&width=1920&height=800&seq=about-hero&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-2xl md:text-4xl font-bold mb-4">
              关于贝斯特体育
            </h1>
            <p className="text-lg md:text-xl mb-6 max-w-2xl mx-auto text-gray-200">
              专注体育直播，用心服务体育爱好者
            </p>
            <div className="w-24 h-1 bg-green-400 mx-auto rounded-full"></div>
          </div>
        </section>

        {/* Company Introduction */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">我们的故事</h2>
                <div className="w-16 h-1 bg-green-500 mx-auto mb-6"></div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20sports%20broadcasting%20studio%20with%20professional%20equipment%2C%20high-tech%20video%20production%20facility%20with%20multiple%20screens%20displaying%20sports%20content%2C%20clean%20contemporary%20broadcast%20center%20with%20green%20and%20blue%20lighting%20accents&width=600&height=400&seq=company-story&orientation=landscape"
                    alt="公司环境"
                    className="w-full h-80 object-cover rounded-lg shadow-lg"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">让体育更精彩</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    贝斯特体育成立于2020年，是一家专注于体育直播和体育社区服务的科技公司。我们致力于为全球体育爱好者提供最优质的观赛体验和最丰富的体育内容。
                  </p>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    通过先进的直播技术和专业的内容团队，我们为用户呈现高清流畅的体育赛事直播，涵盖足球、篮球、网球、游泳等多个体育项目。
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    未来，我们将继续秉承"专业、热情、创新、共享"的价值观，不断提升产品和服务质量，为体育产业的发展贡献力量。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Statistics */}
        <section className="py-16 bg-gradient-to-r from-green-500 to-blue-600">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-white mb-4">我们的成就</h2>
              <p className="text-green-100 text-lg">用数据说话，见证我们的成长</p>
            </div>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${stat.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="text-3xl font-bold text-white mb-2">{stat.number}</div>
                  <div className="text-green-100">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">核心价值观</h2>
              <div className="w-16 h-1 bg-green-500 mx-auto mb-6"></div>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                这些价值观指引着我们的每一个决定，塑造着我们的企业文化
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div key={index} className="bg-white rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${value.icon} text-2xl text-green-600`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Development Timeline */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">发展历程</h2>
              <div className="w-16 h-1 bg-green-500 mx-auto mb-6"></div>
              <p className="text-gray-600 text-lg">见证我们一步步成长的足迹</p>
            </div>
            
            <div className="max-w-4xl mx-auto">
              <div className="relative">
                {/* Timeline line */}
                <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-green-200"></div>
                
                {milestones.map((milestone, index) => (
                  <div key={index} className={`relative flex items-center mb-8 ${
                    index % 2 === 0 ? 'justify-start' : 'justify-end'
                  }`}>
                    {/* Timeline dot */}
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-green-500 rounded-full border-4 border-white shadow-lg z-10"></div>
                    
                    {/* Content */}
                    <div className={`w-5/12 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                        <div className="text-2xl font-bold text-green-600 mb-2">{milestone.year}</div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{milestone.title}</h3>
                        <p className="text-gray-600">{milestone.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">核心团队</h2>
              <div className="w-16 h-1 bg-green-500 mx-auto mb-6"></div>
              <p className="text-gray-600 text-lg">专业的团队，为您提供优质服务</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="w-full h-64 object-cover"
                  />
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h3>
                    <div className="text-green-600 font-medium mb-3">{member.position}</div>
                    <p className="text-gray-600 text-sm leading-relaxed">{member.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid lg:grid-cols-2 gap-12">
                {/* Mission */}
                <div className="text-center lg:text-left">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto lg:mx-0 mb-6">
                    <i className="ri-target-line text-2xl text-green-600"></i>
                  </div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">我们的使命</h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    让全世界的体育爱好者都能便捷地观看到高质量的体育赛事直播，享受体育运动带来的激情与快乐。我们致力于打破地域限制，连接全球体育社区。
                  </p>
                  <div className="flex items-center justify-center lg:justify-start space-x-4">
                    <div className="flex items-center text-green-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">高质量直播</span>
                    </div>
                    <div className="flex items-center text-green-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">全球覆盖</span>
                    </div>
                    <div className="flex items-center text-green-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">社区互动</span>
                    </div>
                  </div>
                </div>

                {/* Vision */}
                <div className="text-center lg:text-left">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto lg:mx-0 mb-6">
                    <i className="ri-eye-line text-2xl text-blue-600"></i>
                  </div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">我们的愿景</h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    成为全球领先的体育直播平台，推动体育产业数字化发展，让体育运动成为连接世界的桥梁，传播积极向上的体育精神和价值观。
                  </p>
                  <div className="flex items-center justify-center lg:justify-start space-x-4">
                    <div className="flex items-center text-blue-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">行业领先</span>
                    </div>
                    <div className="flex items-center text-blue-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">数字创新</span>
                    </div>
                    <div className="flex items-center text-blue-600">
                      <i className="ri-check-line mr-2"></i>
                      <span className="text-sm">文化传播</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 bg-gradient-to-r from-green-500 to-blue-600">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">加入我们</h2>
            <p className="text-green-100 text-lg mb-8 max-w-2xl mx-auto">
              如果你也热爱体育，想要与我们一起为体育事业贡献力量，欢迎加入贝斯特体育大家庭
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-flex items-center px-8 py-3 bg-white text-green-600 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                <i className="ri-mail-line mr-2"></i>
                联系我们
              </a>
              <a
                href="/community"
                className="inline-flex items-center px-8 py-3 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors"
              >
                <i className="ri-group-line mr-2"></i>
                加入社区
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
